<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
    <!-- <ContentSave /> -->
  </div>
</template>

<script>
// import ContentSave from "vue-material-design-icons/ContentSave.vue"

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiContentSave } from "@mdi/js"

export default {
  name: "ContentSaveIcon",
  components: {
    SvgIcon
    // ContentSave,
  },
  data() {
    return {
      path: mdiContentSave,
    }
  }
}
</script>
